import {RefObject, useEffect, useRef} from 'react';

export function useClickOutside(elementRefs: RefObject<HTMLElement>[], callback: (event: MouseEvent) => void): void {
    const callbackRef = useRef(callback);

    callbackRef.current = callback;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            const target = event.target;
            if (!(target instanceof Node) || elementRefs.every((elementRef) => !elementRef.current?.contains(target))) {
                callbackRef.current?.(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);

        return () => document.removeEventListener('click', handleClickOutside, true);
    }, [elementRefs]);
}
